<template>
  <div
    class="modal fade download-modal-container"
    id="contract-expiration-modal"
    data-bs-backdrop="true"
    data-bs-keyboard="true"
    aria-labelledby="contract-expiration-modal-label"
    aria-hidden="true"
  >
    <div class="modal-dialog md2 modal-dialog-centered contract-expiration-modal">
      <div class="modal-content d-flex justify-content-center flex-column align-items-center" >
        <div class="modal-content-body">
          <div class="contract-expiration-header">
            <div class="modal-title">
              서명 기간 수정
            </div>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
            <i class="fa-regular fa-x"/>
            </button>
          </div>
          <div class="contract-expiration-content d-flex justify-content-center flex-column align-items-center">
            <div class="expiration-date-container">
              <div class="icon-wrap">
                <i class="fa-solid fa-triangle-exclamation" />
              </div>
              서명 만료일까지 남은 기간:
              <span class="expiration-date-highlight">{{ computedDatesLeft }}일</span>
            </div>
            <div class="expiration-description">
              서명 만료일을 설정합니다. 만료일까지 서명이 완료되지 않을 시, 계약이 [서명 취소됨] 상태로 바뀝니다.
            </div>
            <div class="expiration-title">
              서명 만료일
              <span class="required-span"/>
            </div>
            <input 
               
              @input="uiHandler.formatDate"
              :value="formattedExpirationDate"
            />
            <div class="date-picker-wrap expiration-modal">
              <VueDatePicker
                :format="uiHandler.formatExpirationDate"
                v-model="expirationDate"
                select-text="선택"
                cancel-text="취소"
                validate
                vertical
                locale="ko-KR"
                :inline="true"
                :enable-time-picker="false"
                auto-apply
                :month-change-on-scroll="false"
                @update:model-value="uiHandler.handleDateChange"

              />
              <!-- 
                       <VueDatePicker
                    v-model="birthday"
                    :format="formatBirthdayVueDatepicker"
                    select-text="선택"
                    cancel-text="취소"
                    validate
                    vertical
                    locale="ko-KR"
                    inline
                    text-input
                    inline-with-input
                    auto-apply
                    :month-change-on-scroll="false"
                  />
               -->
            </div>
          </div>
        </div>
        <div class="expiration-modal-footer">
          <button 
            class="contract-cancel-btn btn-hover"
            data-bs-dismiss="modal"
          >
            취소
          </button>
          <button 
            class="contract-submit-btn btn-hover"
            @click="uiHandler.emitContractInfo"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { oneBtnDialog } from '@/utils/utils';

export default {
  components: {
    VueDatePicker,
  },
  props: {
    selectedContract: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      uiHandler: this.ui(),

      expirationDate: dayjs().format('YYYY/MM/DD'),
      formattedExpirationDate: dayjs().format('YYYY/MM/DD'),
      contractId: '',
    }
  },
  watch: {
    selectedContract(newValue, oldValue) {
      if(newValue && newValue.createContractDate) {
        if(newValue.contractId) this.contractId = newValue.contractId;
        this.uiHandler.setExpirationDate(newValue.createContractDate);
      }
    }
  },
  computed: {
    computedDatesLeft() {
      const today = dayjs();
      const expiration = dayjs(this.expirationDate, 'YYYY/MM/DD');

      // Calculate the difference in days
      const diffInDays = expiration.diff(today, 'day');

      // Ensure the result is not negative and is a valid number
      return isNaN(diffInDays) || diffInDays < 0 ? 0 : diffInDays;
    },
  },
  mounted() {
    this.formattedExpirationDate = this.uiHandler.formatExpirationDate(dayjs());
  },
  methods: {
    ui() {
      const formatExpirationDate = (date) => {
        const formattedDate = dayjs(date).format('YYYY/MM/DD');
        this.expirationDate = formattedDate;
        this.formattedExpirationDate = formattedDate;
      };

      const formatDate = (event) => {
        const result = formatInputToDate(event.target.value);
        event.target.value = result;
        if (result.length === 10) { // YYYY/MM/DD format
          this.expirationDate = dayjs(result, 'YYYY/MM/DD').format('YYYY/MM/DD');
        }
      };

      const setExpirationDate = (dateStr) => {
        const date = dayjs(dateStr).add(3, 'month'); // Add 3 months
        const formattedDate = date.format('YYYY/MM/DD');
        this.expirationDate = formattedDate;
        this.formattedExpirationDate = formattedDate;
      };

      const formatInputToDate = (input) => {
        const onlyNumbers = input.replace(/\D/g, ''); // remove non-digits

        if (onlyNumbers.length <= 4) {
          return onlyNumbers;
        } else if (onlyNumbers.length <= 6) {
          let year = onlyNumbers.slice(0, 4);
          let month = onlyNumbers.slice(4);

          // Validate month
          if (parseInt(month, 10) > 12) {
            month = '12';
          }

          return `${year}/${month}`;
        } else {
          let year = onlyNumbers.slice(0, 4);
          let month = onlyNumbers.slice(4, 6);
          let day = onlyNumbers.slice(6, 8);

          // Validate month and day
          if (parseInt(month, 10) > 12) {
            month = '12';
          }
          if (parseInt(day, 10) > 31) {
            day = '31';
          }

          return `${year}/${month}/${day}`;
        }
      }


      const emitContractInfo = () => {
        if(!this.formattedExpirationDate) {
          oneBtnDialog('서명 만료일 미선택', '서명 만료일을 선택해 주세요.', false);
          return;
        } 
        const obj = {};
        const newDate = this.formattedExpirationDate.replaceAll('/', '-');

        obj.date = newDate;
        obj.contractId = this.contractId;
        this.$emit('emit-expiration-date', obj);
      }

      const handleDateChange = (event) => {
        const today = dayjs();
        const expiration = dayjs(this.expirationDate, 'YYYY/MM/DD');

        // Calculate the difference in days
        const diffInDays = expiration.diff(today, 'day');

        if (diffInDays < 0) {
          oneBtnDialog('날짜 선택 오류', '서명 만료일은 오늘 이전으로 설정할 수 없습니다.', false);
          this.expirationDate = today.format('YYYY/MM/DD');
        }
      };
      
      return {
        formatExpirationDate,
        setExpirationDate,
        formatDate,
        emitContractInfo,
        handleDateChange,
      }
    },
    /* 
      달력 패키지로 생일 선택 시 포맷팅
    */
    
  }
}
</script>
<style scoped lang="scss">
  @import '@/assets/scss/contract-expiration-modal.scss';
</style>